import React, { useContext, useState } from 'react';
import { Col, Image, Row } from 'react-bootstrap';
import 'assets/styles/common.scss';
import AbsolutLogo from 'assets/images/absolute-logo.svg';
import ReusableButton from 'components/commom/Button';
import { useNavigate } from 'react-router-dom';
import { LocaleContext } from 'routes/Router';
import { useDispatch, useSelector } from 'react-redux';
import { loginUsers } from 'store/login/LoginAction';
import { ClearTokenRedirectLogin, enCodeBase64 } from 'utils/general';
import { dashboard, enterpriseDashboard } from 'routes/AppUrls';
import LocalStorageManager from 'managers/LocalStorageManger';
import CommonToast from 'components/commom/CommonToast';
import { MuiOtpInput } from 'mui-one-time-password-input';
import styled from 'styled-components';
import { adminOtpVerifyCallAPI } from 'store/AdminOtpVerify/AdminOtpVerifyAction';

const CustomMuiOtpInput = styled(MuiOtpInput)({
  '& .MuiOutlinedInput-root': {
    border: 'none',
    borderBottom: '1px solid #864629',
    borderRadius: '0px',
    fontSize: '32px',
    fontWeight: 400,
    lineHeight: '48px',
    color: '#3C3C3C',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
    borderRadius: '0px',
  },
});

const Otp = () => {
  const dispatch = useDispatch();
  const { showToast } = CommonToast();
  const navigate = useNavigate();
  const { locale } = useContext(LocaleContext);
  const [otpValue, setOtpValue] = useState('');

  const otpVerifyLoader = useSelector(
    (state) => state?.adminOtpVerifyReducer?.loading
  );

  const loginData = useSelector(
    (state) => state?.basicDetailsValueReducer?.loginDetails
  );

  const handleOtpVerify = () => {
    if (otpValue.length === 6) {
      const external = {
        run: true,
        handleFunction: (res) => {
          LocalStorageManager.setItem('token', res?.data?.key);
          LocalStorageManager.setItem('Role', res?.data?.role);
          if (res?.data?.role === 'super-admin') {
            navigate(dashboard(locale));
          }
          if (res?.data?.role === 'enterprise-admin') {
            navigate(enterpriseDashboard(locale));
          }
        },
        authorize: true,
        handleAuthorizeFunction: (res) => {},
        error: true,
        handleErrorFunction: (res) => {
          showToast(res?.message, 'error');
        },
      };
      let body = {
        username: loginData?.email,
        otp: otpValue,
        fcm_token: 'string',
      };
      dispatch(adminOtpVerifyCallAPI(body, external));
    } else {
      showToast('Please enter 6 digit otp', 'error');
    }
  };

  const handleChange = (e) => {
    setOtpValue(e);
  };

  const hanldeResend = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        showToast(res?.message, 'success');
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    const body = {
      username: loginData?.email,
      password: enCodeBase64(loginData?.password),
    };
    dispatch(loginUsers(body, external));
  };

  return (
    <>
      <Row className="m-0 p-0 landing-image">
        <Row className="m-0 p-0 flex justify-content-center">
          <Col
            xs={12}
            sm={10}
            md={10}
            lg={6}
            xl={6}
            xxl={4}
            className="bg-light-100 m-sm-auto m-lg-auto login-card p-0"
          >
            <div class="py-60 px-40">
              <div className="d-flex">
                <Image src={AbsolutLogo} alt={'icon'} />
              </div>
              <div className="main-heading pt-24 family_outfit_semiBold_600">
                Verification
              </div>
              <div className="pt-12 fs-20 family_outfit_regular_400 lh-26 fc-6B788E">
                Enter the OTP has been sent on your registered email address.
              </div>
              <Row>
                <Col sm={12} className="">
                  <div className="pt-40">
                    <CustomMuiOtpInput
                      length={6}
                      value={otpValue}
                      onChange={handleChange}
                    />
                  </div>
                </Col>
              </Row>
              <div className="fs-18 family_outfit_regular_400 lh-27 fc-7F7F7F pt-40 flex justify-center">
                Did not receive the OTP?
              </div>
              <div
                className="fs-20 family_outfit_medium_500 fc-3C3C3C lh-30 pt-04 flex justify-center cursor-pointer ..."
                onClick={() => hanldeResend()}
              >
                Resend
              </div>
              <div className="pt-28">
                <ReusableButton
                  fullWidth={true}
                  variant="outlined"
                  color="#F5F5F5"
                  fontSize="16px"
                  fontWeight="500"
                  padding="12px 24px"
                  borderRadius="8px"
                  height="48px"
                  bgColor="#2C2C2C"
                  brColor=""
                  fontFamily="outfit_semiBold"
                  onClick={() => {
                    !otpVerifyLoader && handleOtpVerify();
                  }}
                  loading={otpVerifyLoader}
                >
                  Verify
                </ReusableButton>
              </div>
            </div>
          </Col>
        </Row>
      </Row>
    </>
  );
};
export default Otp;
